import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Toaster } from 'sonner';
import { LocationProvider } from './context/LocationContext';
import StorageUtil from './utils/StorageUtil';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <LocationProvider>
    <App />
    <Toaster position="top-right" richColors />
    <StorageUtil />
  </LocationProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
